import { connect } from 'react-redux'
import AlertModalView from 'support/popup_dialogs/views/components/alert_modal_view/AlertModalView'
import { hideDialog } from 'support/popup_dialogs/modal_alert_controller/ModalActions'
import Navigation from 'support/navigation'
import i18n from 'support/i18n'

const mapStateToProps = (props,Ownprops) => {
  return{
    title: i18n.t('CONFIRMATION_MESSAGE'),
    description: Ownprops.description,
    mainButtonText: i18n.t('ACCEPT'),
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
     const {response } = ownProps
     
  return {
    mainButtonAction: async () => {
      dispatch(hideDialog())
      // await dispatch(Navigation.navigateToAllIdeas())
     await dispatch(Navigation.navigateToInnovateIdea(response.idea.id))
      // window.location.reload()
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AlertModalView)
